import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Fade from '@mui/material/Fade';

export default function BasicAlert({ openAlert, onClose, title, content }) {
  return (
    <Fade in={openAlert}>
      <Alert
        variant="filled" 
        severity="error"
        onClose={onClose}
        sx={{ 
          bgcolor: '#15326f',
          textcolor: "black",
          borderRadius: '12px',
          position: 'fixed', 
          top: 50,
          right: 70,
          width: "30vw",
          minWidth: 330,
          zIndex: 9999,
        }} 
      >
        <AlertTitle sx={{ fontFamily: 'Sans', fontSize: '19px', fontWeight: '1000' }}>
          {title}
        </AlertTitle>
        {content}
      </Alert>
    </Fade>
  )
}